'use client';

import { PrivyClientConfig } from '@privy-io/react-auth';

const privyAppId = process.env.NEXT_PUBLIC_PRIVY_APP_ID!;
const privyClientId = process.env.NEXT_PUBLIC_PRIVY_CLIENT_ID!;

if (!privyAppId) {
  throw new Error('NEXT_PUBLIC_PRIVY_APP_ID is not set');
}

if (!privyClientId) {
  throw new Error('NEXT_PUBLIC_PRIVY_CLIENT_ID is not set');
}

interface PrivyConfig {
  appId: string;
  clientId: string;
  config: PrivyClientConfig;
}

export const PRIVY_CONFIG: PrivyConfig = {
  appId: privyAppId,
  clientId: privyClientId,
  config: {
    embeddedWallets: {
      createOnLogin: 'users-without-wallets',
      showWalletUIs: true,
    },
    loginMethods: ['email', 'passkey', 'google', 'telegram', 'wallet'],
    appearance: {
      theme: 'dark',
      accentColor: '#9662E1',
      logo: 'https://lander.yodl.me/logo.svg',
    },
  },
} as const;
